import { Module } from "vuex";
import RootState from "./root-state";
import { ProjectFolderDefault } from "@/api/project/project-folder-default-api";

import ProjectFolderDefaultApi from "@/api/gateways/folder-default-api";
import { FolderDefaultId } from "@/entities/ids";

export default {
  namespaced: true,
  state: {
    keys: []
  },
  getters: {
    all: state => (type: string) => {
      return state.keys.filter(t => t.type === type);
    }
  },
  mutations: {
    init(state, keys: ProjectFolderDefault[]) {
      state.keys = keys;
    }
  },
  actions: {
    async init({ commit, rootGetters }) {
      const gw = new ProjectFolderDefaultApi(rootGetters.api);
      commit("init", await gw.all());
    },
    async sort(
      { commit, dispatch, rootGetters },
      keys: ProjectFolderDefault[]
    ) {
      // 一旦代入しないとDnDでラグが生じる
      commit("init", keys);
      const gw = new ProjectFolderDefaultApi(rootGetters.api);
      const ids = keys.map(t => t.id);
      await gw.sort(ids.map(id => Number(id))); // Convert array of strings to array of numbers
      await dispatch("init");
    },
    async remove({ dispatch, rootGetters }, id: FolderDefaultId) {
      const gw = new ProjectFolderDefaultApi(rootGetters.api);
      await gw.remove(id);
      await dispatch("init");
    }
  }
} as Module<keystate, RootState>;

interface keystate {
  keys: ProjectFolderDefault[];
}
